import { Input } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';

const CREDENTIAL_I18N = 'features:partners.components.credential' satisfies I18nPrefix;

export function CredentialField({
  label,
  placeholder,
  value,
  onChange,
  hasStoredValue,
  error,
  type = 'password',
  tooltip,
}: {
  label: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  hasStoredValue: boolean;
  error?: string;
  type?: 'text' | 'password';
  tooltip?: string;
}) {
  const displayLabel = t(
    hasStoredValue ? `${CREDENTIAL_I18N}.update` : `${CREDENTIAL_I18N}.enter`,
    { label },
  );
  const displayPlaceholder = hasStoredValue
    ? t(`${CREDENTIAL_I18N}.masked_placeholder`)
    : placeholder;

  return (
    <Input
      type={type}
      label={displayLabel}
      placeholder={displayPlaceholder}
      value={value}
      onChange={onChange}
      error={error}
      tooltip={tooltip}
      autoComplete="new-password"
    />
  );
}
